import * as tslib_1 from "tslib";
import { createAction, createReducer, on } from "@ngrx/store";
export var Lookups;
(function (Lookups) {
    Lookups.updateAgencies = createAction('[Lookups] - Update Agencies', function (items) { return ({ items: items }); });
    Lookups.loadAgencies = createAction('[Lookups] - Load Agencies');
    Lookups.updateAgencyObjects = createAction('[Lookups] - Update Agency Objects', function (items) { return ({ items: items }); });
    Lookups.loadAgencyObjects = createAction('[Lookups] - Load Agency Objects');
    Lookups.updateUnions = createAction('[Lookups] - Update Unions', function (items) { return ({ items: items }); });
    Lookups.loadUnions = createAction('[Lookups] - Load Unions');
    Lookups.updateUnionObjects = createAction('[Lookups] - Update Union Objects', function (items) { return ({ items: items }); });
    Lookups.loadUnionObjects = createAction('[Lookups] - Load Union Objects');
    Lookups.updateOlmrNumbers = createAction('[Lookups] - Update OlmrNumbers', function (items) { return ({ items: items }); });
    Lookups.loadOlmrNumbers = createAction('[Lookups] - Load OlmrNumbers');
    Lookups.updateBusCodes = createAction('[Lookups] - Update BusCodes', function (items) { return ({ items: items }); });
    Lookups.loadBusCodes = createAction('[Lookups] - Load BusCodes');
    Lookups.updateBusCodeObjects = createAction('[Lookups] - Update BUS Code Objects', function (items) { return ({ items: items }); });
    Lookups.loadBusCodeObjects = createAction('[Lookups] - Load BUS Code Objects');
    Lookups.updateCpdfCodeObjects = createAction('[Lookups] - Update CPDF Code Objects', function (items) { return ({ items: items }); });
    Lookups.loadCpdfCodeObjects = createAction('[Lookups] - Load CPDF Code Objects');
    Lookups.updateAffiliationObjects = createAction('[Lookups] - Update Affiliation Objects', function (items) { return ({ items: items }); });
    Lookups.loadAffiliationObjects = createAction('[Lookups] - Load Affiliation Objects');
    var initialLookupState = {
        agencies: [],
        agencyObjects: [],
        unions: [],
        unionObjects: [],
        olmrNumbers: [],
        cpdfCodeObjects: [],
        busCodes: [],
        busCodeObjects: [],
        affiliationObjects: []
    };
    var lookupReducer = createReducer(initialLookupState, on(Lookups.updateAgencies, function (state, _a) {
        var items = _a.items;
        return tslib_1.__assign({}, state, { agencies: items });
    }), on(Lookups.updateAgencyObjects, function (state, _a) {
        var items = _a.items;
        return tslib_1.__assign({}, state, { agencyObjects: items });
    }), on(Lookups.updateUnions, function (state, _a) {
        var items = _a.items;
        return tslib_1.__assign({}, state, { unions: items });
    }), on(Lookups.updateUnionObjects, function (state, _a) {
        var items = _a.items;
        return tslib_1.__assign({}, state, { unionObjects: items });
    }), on(Lookups.updateOlmrNumbers, function (state, _a) {
        var items = _a.items;
        return tslib_1.__assign({}, state, { olmrNumbers: items });
    }), on(Lookups.updateCpdfCodeObjects, function (state, _a) {
        var items = _a.items;
        return tslib_1.__assign({}, state, { cpdfCodeObjects: items });
    }), on(Lookups.updateBusCodes, function (state, _a) {
        var items = _a.items;
        return tslib_1.__assign({}, state, { busCodes: items });
    }), on(Lookups.updateBusCodeObjects, function (state, _a) {
        var items = _a.items;
        return tslib_1.__assign({}, state, { busCodeObjects: items });
    }), on(Lookups.updateAffiliationObjects, function (state, _a) {
        var items = _a.items;
        return tslib_1.__assign({}, state, { affiliationObjects: items });
    }));
    function reducer(state, action) {
        if (state === void 0) { state = initialLookupState; }
        return lookupReducer(state, action);
    }
    Lookups.reducer = reducer;
})(Lookups || (Lookups = {}));
